import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DomainService } from '../apis/domain.service';
import { storageKeys } from 'src/app/share/configs';
import { WindowService } from '../local/window.service';

@Injectable({
  providedIn: 'root',
})
export class HomeGuard implements CanActivate {
  private readonly firstPartyHosts = new Set(['uorder.io', 'www.uorder.io', 'localhost']);
  private readonly router = inject(Router);

  constructor(
    private domainServe: DomainService,
    private windowServe: WindowService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean | UrlTree {
    const hostname = window.location.hostname;
    if (this.isFirstPartyHost(hostname)) {
      return true;
    }

    const secure = window.location.protocol === 'https:';
    return this.domainServe
      .postDomain({
        Domain: hostname,
        secure,
      })
      .pipe(
        map((res) => {
          const domain = res?.data?.item;
          if (!domain?.store_id || !domain?.merchant_id) {
            return true;
          }

          this.windowServe.setLocalStorage(
            storageKeys.store,
            domain.store_id.toString()
          );
          this.windowServe.setLocalStorage(
            storageKeys.merchant,
            domain.merchant_id.toString()
          );

          return this.router.createUrlTree([
            '/store',
            domain.store_id.toString(),
          ]);
        }),
        catchError(() => of(true))
      );
  }

  private isFirstPartyHost(hostname: string): boolean {
    if (this.firstPartyHosts.has(hostname)) {
      return true;
    }
    return hostname.startsWith('localhost:');
  }
}
